const Notifydata = [
      {
          id: 1,
          note: "Amanda Fischi followed you."
      },
      {
          id: 2,
          note: "Optimize your profile for more visits."
      },
      {
          id: 3,
          note: "Jotaro Zaworldo viewed your profile."
      },
      {
          id: 4,
          note: "Erza Scarlet and Mamashi Kishimoto liked your profile picture."
      },
      {
          id: 5,
          note: "Welcome to the Sendmie-app, where positivity reigns."
      },
]

export default Notifydata;